import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Proptypes from 'prop-types';
import { useCookies } from 'react-cookie';

function PublicRoute(props) {
  const {
    component: Component,
    newIsAdmin = false,
    newUserType = '',
    isAuthenticated = false,
    adminRedirect = '/dashboard',
    supervisorRedirect = '/profiles',
    privateRedirect = '/',
    ...rest
  } = props;

  const [cookies = {}] = useCookies(['newUserType']);

  return (
    <Route
      {...rest}
      render={(props) => {
        return isAuthenticated ? (
          <Redirect
            push={false}
            to={{
              pathname: newIsAdmin
                ? newUserType === 'SUPER_ADMIN'
                  ? adminRedirect
                  : supervisorRedirect
                : '/choose-service',
              state: { from: props.location },
            }}
          />
        ) : (
          <Component {...props} />
        );
      }}
    />
  );
}

PublicRoute.propTypes = {
  component: Proptypes.func.isRequired,
  privateDefaultPath: Proptypes.string,
  isAuthenticated: Proptypes.bool,
};

export default PublicRoute;
